module.exports = __webpack_public_path__ + "static/media/laxaar-logo.558a745e.png";